<template>
    <div id="notification">
        <div class="ui orange icon message" v-if="notification.urgent">
            <i class="wrench icon" aria-hidden="true"></i>
            <div class="content">
                <div class="header">
                    {{ notification.title }}
                </div>
                <div class="timestamp">
                    <span class="shutdown" v-if="notification.estimated_shutdown">
                        {{
                            $moment(
                                notification.estimated_shutdown
                            ).locale("zh-tw").format('YYYY-MM-DD HH:mm')
                        }}
                    </span>
                    <span>
                        {{ continued_help }}
                    </span>
                    <span class="boot" v-if="notification.estimated_boot">
                        {{
                            $moment(
                                notification.estimated_boot
                            ).locale("zh-tw").format('YYYY-MM-DD HH:mm')
                        }}
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification: Object,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
        continued_help() {
            if (
                !this.notification.estimated_shutdown &&
                !this.notification.estimated_boot
            ) {
                return ""
            } else if (
                this.notification.estimated_shutdown &&
                !this.notification.estimated_boot
            ) {
                return "關機"
            } else if (
                !this.notification.estimated_shutdown &&
                this.notification.estimated_boot
            ) {
                return "預計開機時間："
            } else {
                return "~"
            }
        },
    },
    methods: {
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
    #notification {
        padding-bottom: 6px;
    }
    .timestamp {
        font-weight: bold;
        color: #666;
        padding-top: 3px;
    }
    .timestamp span {
        padding: 3px;
    }
    .boot {
        color: #4347e8;
    }
</style>
